/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useClient from "./useInspectionClient";
import { trackPromise } from "react-promise-tracker";

export const useData = <T,>(endpoint: string, isGetPreviousData?: boolean): T | undefined => {
    const client = useClient();
    const [data, setData] = useState<T>();
    const [lastData, setLastData] = useState<T>();

    useEffect(() => {
        const getData = async () => {
            try {
                const response = await client.api(endpoint).get();
                // console.log("get call");
                isGetPreviousData ? setLastData(response.data as T) : setData(response.data as T);
            } catch (error: any) {
                toast.error(error);
            }
        };

        if (endpoint) {
            if (isGetPreviousData) {
                trackPromise(getData());
            } else {
                // Always fetch when endpoint changes (reset data first to ensure fresh fetch)
                setData(undefined);
                trackPromise(getData());
            }
        } else {
            // Clear data when endpoint is empty
            if (!isGetPreviousData) {
                setData(undefined);
            }
        }
    }, [endpoint, isGetPreviousData]);

    return isGetPreviousData ? lastData : data;
};

export default useData;
